import { IntlShape } from 'react-intl';
import changePhoneNumberMessages from '../../../../messages/change-phone-number.messages';
import commonErrorMessages from '../../../../messages/common-messages/common-error.messages';
import { ErrorMessages, FormattedErrorMessages } from '../../../../model/error';
import { isPhoneNumberValid } from '../../../../utils/validators';
import {
  ChangePhoneNumberExpiredDocumentError,
  ChangePhoneNumberState,
  InsertPhoneNumberChangePhoneNumberError,
  VerificationPhoneNumberChangePhoneNumberError,
} from './change-phone-number-type';

export const verifyInsertPhoneNumberChangePhoneNumberFields = (
  state: ChangePhoneNumberState
): InsertPhoneNumberChangePhoneNumberError | undefined => {
  const { phoneNumber, confirmNewPhoneNumber } = state;

  if (phoneNumber !== confirmNewPhoneNumber) {
    return 'PHONE_NUMBERS_NOT_MATCHING';
  }
  if (!isPhoneNumberValid(phoneNumber)) {
    return 'INVALID_PHONE_NUMBER_FORMAT';
  }
  return undefined;
};

export const verifyInsertPhoneNumberChangeSecondaryPhoneNumberFields = (
  state: ChangePhoneNumberState,
  principalPhoneNumber: string
): InsertPhoneNumberChangePhoneNumberError | undefined => {
  const { secondaryPhoneNumber, confirmNewSecondaryPhoneNumber } = state;

  if (secondaryPhoneNumber !== confirmNewSecondaryPhoneNumber) {
    return 'PHONE_NUMBERS_NOT_MATCHING';
  }
  if (!isPhoneNumberValid(secondaryPhoneNumber)) {
    return 'INVALID_PHONE_NUMBER_FORMAT';
  }

  if (
    principalPhoneNumber?.replaceAll(' ', '') ===
    secondaryPhoneNumber?.replaceAll(' ', '')
  ) {
    return 'PHONE_ALREADY_USED';
  }
  return undefined;
};

export const messagesForInsertPhoneNumberChangePhoneNumberError = (
  error: InsertPhoneNumberChangePhoneNumberError
): ErrorMessages => {
  switch (error) {
    case 'INVALID_PHONE_NUMBER_FORMAT':
      return {
        title: changePhoneNumberMessages.errorInvalidPhoneNumberFormat,
      };
    case 'PHONE_NUMBERS_NOT_MATCHING':
      return {
        title: changePhoneNumberMessages.errorPhoneNumbersNotMatching,
      };
    case 'CELLULARE_NON_UTILIZZABILE':
      return {
        title: changePhoneNumberMessages.errorPhoneNumberNotUsable,
      };
    case 'PHONE_ALREADY_USED':
      return {
        title: changePhoneNumberMessages.errorPhoneNumberAlreadyUsed,
      };
    case 'GENERIC_ERROR':
    default:
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
  }
};

export const messagesForVerificationPhoneNumberChangePhoneNumberError = (
  error: VerificationPhoneNumberChangePhoneNumberError,
  intl?: IntlShape
): FormattedErrorMessages => {
  const { formatMessage } = intl;
  switch (error.type) {
    case 'CODICE_DI_VERIFICA_SBAGLIATO':
      return {
        title: formatMessage(changePhoneNumberMessages.errorWrongCode, {
          attemptsEmail: error.attemptsEmail,
          attemptsPhoneNumber: error.attemptsPhoneNumber,
        }),
      };
    case 'CODICE_DI_VERIFICA_EMAIL_SBAGLIATO':
      return {
        title: formatMessage(changePhoneNumberMessages.wrongOtpCodeEmailError, {
          attemptsEmail: error.attemptsEmail,
          attemptsPhoneNumber: error.attemptsPhoneNumber
        }),
      };
    case 'CODICE_DI_VERIFICA_CELLULARE_SBAGLIATO':
      return {
        title: formatMessage(changePhoneNumberMessages.wrongOtpCodePhoneError, {
          attemptsEmail: error.attemptsEmail,
          attemptsPhoneNumber: error.attemptsPhoneNumber
        }),
      };
    case 'GENERIC_ERROR':
    default:
      return {
        title: formatMessage(commonErrorMessages.errorTitleDefault),
        description: formatMessage(commonErrorMessages.errorDescriptionDefault),
      };
  }
};

export const messagesForChangePhoneNumberExpiredDocumentError = (
  error: ChangePhoneNumberExpiredDocumentError
): ErrorMessages => {
  switch (error) {
    case 'DOCUMENTO_SCADUTO':
      return {
        title: changePhoneNumberMessages.errorExpiredDocument,
      };
    case 'GENERIC_ERROR':
    default:
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
  }
};
